import { B000010AuthResponse } from "clients/rest";
import { atom } from "recoil";

export type Auth = {
  shainCd: string;
  shainNm: string;
  shainKana: string;
  taishaYmd: string;
  sakujoyoteiKbn: number;
  eigyoCd: string;
  eigyoNm: string;
  eigyoNmr: string;
  eigyoKana: string;
  bumonCd: string;
  bumonNm: string;
  bumonNmr: string;
  bumonKana: string;
  kengenId: string;
  kengenNm: string;
};

export const authState = atom<Auth | undefined>({
  key: "userState",
  default: undefined,
});

export const getAuth = (value: B000010AuthResponse) => {
  return {
    shainCd: value.shainCd,
    shainNm: value.shainNm,
    shainKana: value.shainKana,
    taishaYmd: value.taishaYmd,
    sakujoyoteiKbn: value.sakujoyoteiKbn,
    eigyoCd: value.eigyoCd,
    eigyoNm: value.eigyoNm,
    eigyoNmr: value.eigyoNmr,
    eigyoKana: value.eigyoKana,
    bumonCd: value.bumonCd,
    bumonNm: value.bumonNm,
    bumonNmr: value.bumonNmr,
    bumonKana: value.bumonKana,
    kengenId: value.kengenId,
    kengenNm: value.kengenNm,
  };
};
